import { inject, Component, OnInit, ViewChild, ViewContainerRef, AfterContentInit, forwardRef, EventEmitter, Output, Input, OnDestroy, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { GlobalConfig, BaseConfig } from './editor/configuration/config';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { TagInputModule } from "ngx-chips";
import { FormatCcPipe } from "../pipes/formatcc.pipe";
import { TPipe } from '../i18n/t.pipe';
import { I18nService } from '../i18n';

const defaultCnf: GlobalConfig = {
  name: '',
  required: false,
  placeholder: '',
  title: '',
  pattern: undefined
};

@Component({
    selector: 'rocket-edit',
    templateUrl: 'rocket-edit.component.html',
    styleUrls: ['rocket-edit.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RocketEditComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TPipe, NgSelectModule, ReactiveFormsModule, CommonModule, TagInputModule, FormatCcPipe]
})
export class RocketEditComponent {
  private i18n = inject(I18nService);

  
  @ViewChild('rocketinput', { static: false }) rocketinput: ElementRef; 

  @Output() public Save: EventEmitter<any> = new EventEmitter(); 
  @Input() pattern;
  @Input() name;
  @Input() placeholder;
  @Input() title;
  @Input() required;
  @Input() editable: boolean = true;
  @Input() empty = this.i18n.t('core.rocket_edit.click_to_add', 'Click to add');
  @Input() mode:string = "text";
  @Input() options: string[];
  
  editValue: UntypedFormControl;
  private _value = '';
  private focusOutTriggered = false;

  config: BaseConfig;
  editing = false;

  @Input()
  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.editValue.setValue(v);
    }
  }
  get value(): any { return this._value; }  

  constructor(private cd: ChangeDetectorRef) {

    this.editValue = new UntypedFormControl(null);

  }

  initializeConfig(): GlobalConfig {
    return {
      name: this.name ? this.name : defaultCnf.name,
      placeholder: this.placeholder ? this.placeholder : defaultCnf.placeholder,
      required: this.required ? this.required : defaultCnf.required,
      pattern: this.pattern ? this.pattern : defaultCnf.pattern,
      title: this.title ? this.title : defaultCnf.title,
    };
  }

  edit(value) {
  
    this.editing = true;
    setTimeout(_ => this.rocketinput.nativeElement?.focus());
  
  }

  save() {

    this.Save.emit( this.editValue.value );
    this.editing = false;
    this.cd.detectChanges();
  }

  cancel() {
    this.editing = false;
  }


  focusout(event) {
    
    // the focusout occurs before the click action on webkit browsers
    // so the save action event is mousedown instead of click
    // @see https://stackoverflow.com/a/52037817/226256
    if(event.relatedTarget && event.relatedTarget.classList.contains('editor-button-save') ) {
      this.focusOutTriggered = true;
    } else {
      if(!this.focusOutTriggered) {
        this.cancel();
      }
      this.focusOutTriggered = false;
    }
  }

  validate() {
    return this.editValue.valid;
  }


}
